import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import _isNumber from 'lodash/isNumber';
import MessageDisplayBanner from './components/MessageDisplayBanner';
import MessageDisplayModal from './components/MessageDisplayModal';
import useIsClient from '../../hooks/use-is-client';
import useStorage from '../../hooks/use-storage';
import { DEFAULT_MODAL_ANIMATION } from '../../modules/foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../modules/foundation/components/Modal/Modal.types';
import Storage from '../../services/storage';
import DateUtils from '../../utils/date/DateUtils';
import './MessageDisplay.css';
var MODAL_KEY = 'showFishermanBannerModalMessage';
var BANNER_KEY = 'showFishermanBannerMessage';
var defaultProps = {
  subTitle: '',
  content: null,
  modalDelay: false,
  bannerBackgroundColor: '',
  modalButtonText: 'See More',
  modalHeader: null,
  modalExtra: /*#__PURE__*/React.createElement("div", null),
  disableCache: false,
  disableModalButton: false,
  startTime: null,
  endTime: null,
  timezone: null,
  modalAnimation: DEFAULT_MODAL_ANIMATION
};
export default function MessageDisplay(_ref) {
  var modalDelay = _ref.modalDelay,
    disableCache = _ref.disableCache,
    businessName = _ref.businessName,
    subject = _ref.subject,
    subTitle = _ref.subTitle,
    content = _ref.content,
    bannerBackgroundColor = _ref.bannerBackgroundColor,
    modalHeader = _ref.modalHeader,
    modalExtra = _ref.modalExtra,
    modalButtonText = _ref.modalButtonText,
    disableModalButton = _ref.disableModalButton,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    timezone = _ref.timezone,
    modalAnimation = _ref.modalAnimation;
  var _useIsClient = useIsClient(),
    isClient = _useIsClient.isClient;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showBanner = _useState4[0],
    setShowBanner = _useState4[1];
  var _useStorage = useStorage(MODAL_KEY, false, {
      storageMechanism: Storage.SESSION_STORAGE
    }),
    _useStorage2 = _slicedToArray(_useStorage, 3),
    modalShownInSession = _useStorage2[0],
    setModalShownInSession = _useStorage2[1],
    storageLoaded = _useStorage2[2];
  var _useStorage3 = useStorage(BANNER_KEY, true, {
      storageMechanism: Storage.SESSION_STORAGE
    }),
    _useStorage4 = _slicedToArray(_useStorage3, 2),
    bannerShownInSession = _useStorage4[0],
    setBannerShownInSession = _useStorage4[1];
  var isButtonDisabled = content ? disableModalButton : true;
  function displayModal() {
    setShowModal(true);
  }
  function closeModal() {
    if (!disableCache) {
      // If we showed the modal, make sure we don't show it again in the same session
      setModalShownInSession(true);
    }
    setShowModal(false);
  }
  useEffect(function () {
    var modalTimeout;
    var isValidDelay = _isNumber(modalDelay) && modalDelay >= 0;
    var shouldDelayDisplay = isValidDelay && (!modalShownInSession || disableCache) && storageLoaded;
    if (shouldDelayDisplay) {
      modalTimeout = setTimeout(displayModal, modalDelay || 0);
    }
    return function () {
      clearTimeout(modalTimeout);
    };
  }, [storageLoaded]);
  if (!isClient || !DateUtils.isNowBetweenDates(startTime, endTime, timezone)) {
    return null;
  }
  if (!showBanner || !bannerShownInSession) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "fm-message-display-container"
  }, showBanner && bannerShownInSession && /*#__PURE__*/React.createElement(MessageDisplayBanner, {
    subject: subject,
    onClick: displayModal,
    onClose: function onClose() {
      setShowBanner(false);
      setBannerShownInSession(false);
    },
    backgroundColor: bannerBackgroundColor,
    buttonText: modalButtonText,
    disableButton: isButtonDisabled
  }), content && /*#__PURE__*/React.createElement(MessageDisplayModal, {
    businessName: businessName,
    open: showModal,
    subject: subject,
    subTitle: subTitle,
    content: content,
    onClose: closeModal,
    extra: modalExtra,
    header: modalHeader,
    animation: modalAnimation
  }));
}
MessageDisplay.defaultProps = defaultProps;